import React, { Component } from 'react'
import AOS from 'aos';
import './css/learning.css'
import Whattolearn from "./Whattolearn"

class Mentees extends Component {
    componentDidMount() {
        // or simply just AOS.init();
        AOS.init({
          // initialise with other settings
          duration : 1000
        });
      }
    render() {
        return (
            <div className="learning">
                <div className="learning-image">
                    <div className="learning-text"  data-aos="fade-up" data-aos-delay="100" data-aos-duration="1600">
                        <h1 className="bold">OUR LEARNING CURVE</h1>
                        <h4 className="mt-10">Taking our course will be complemented with several activities expected to help facilitate the understanding of certain concepts that will be taught along the way. We have in place group & Individual tasks, Q&A sessions, mentor’s access and several other programs to help accelerate our student’s learning.</h4>
                    </div>
                </div>
                <Whattolearn/>
            </div>  
        )
    }
}

export default Mentees;